<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col sm="4" md="3" lg="2" xl="1"  class="nav-left">
                    <SideMenu />
                </v-col>
                <v-col sm="8" md="9" lg="10" xl="11" class="nav-right py-0 pl-10 mt-10 pb-10">
                    <!-- <v-row justify="center" align="center" class="dashboard pt-8 mx-0"> -->
                        <v-tabs v-model="tab" grow>
                            <v-tabs-slider class="dashboard-tab__slider"></v-tabs-slider>
                            <v-tab class="dashboard-tab rounded-tl-lg" href="#offers" @click="changeTab('offers')">
                                <div :class="`dashboard-tab__front${page.tab === 'offers' ? '--active' : ''} rounded-t-lg`">
                                    <span :class="`dashboard-tab__title${page.tab === 'offers' ? '--active' : ''}`">OFERTAS</span>
                                </div>
                            </v-tab>
                            <v-tab class="dashboard-tab rounded-tr-lg" href="#orgs" @click="changeTab('orgs')">
                                <span :class="`dashboard-tab__front${page.tab === 'orgs' ? '--active' : ''} rounded-t-lg`">
                                    <span :class="`dashboard-tab__title${page.tab === 'orgs' ? '--active' : ''}`">ORGANIZACIONES</span>
                                </span>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab" class="pt-0 px-1 pb-1 pl-xl-10">
                            <v-tab-item id="offers" value="offers" class="pt-2 pl-xl-10">
                                <v-card>
                                    <v-card-title>
                                        Ofertas: 
                                        <v-spacer></v-spacer>
                                        <v-col class="my-0 py-0 mx-2 d-flex justify-end">
                                            <v-label>
                                                Agregar Cerradas
                                            </v-label>
                                            <v-switch
                                                v-model="addClosed"
                                                class="mx-3"
                                                color="info"
                                                inset
                                                hide-details
                                                :loading="isLoadingCloseOffers"
                                                :disabled="isLoadingOffers || isLoadingCloseOffers"
                                            >
                                            </v-switch>
                                        </v-col>
                                        <v-text-field
                                            class="elevation-0"
                                            v-model="searchOffers"
                                            append-icon="mdi-magnify"
                                            label="Buscar"
                                            single-line
                                            hide-details
                                        ></v-text-field>
                                    </v-card-title>
                                    <v-data-table
                                        :search="searchOffers"
                                        :headers="headersOffers"
                                        :items="page.offers.data"
                                        sort-by="id"
                                        :sort-desc="[true]"
                                        :loading="isLoadingOffers"
                                        item-key="id"
                                        class="elevation-5 pa-1"
                                        :items-per-page="page.offers.itemsPerPage"
                                        :custom-filter="filterOffersText"
                                    >
                                        <template v-slot:item.actions="{ item }">
                                            <v-icon small class="mr-2" @click="editOffersItem(item)">
                                                mdi-pencil
                                            </v-icon>
                                        </template>
                                        <template v-slot:item.tabulated="{ item }">
                                            <span>
                                                {{item.tabulated ? "Pagado" : "No Pagado"}}
                                            </span>
                                        </template>
                                        <template v-slot:loading>
                                            <div style="margin-top: 20px !important; margin-bottom: 600px !important;">
                                                Cargando las ofertas ... ({{offersLoaded}}%)
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item id="orgs" value="orgs" class="pt-2 pl-xl-10">
                                <v-card>
                                    <v-card-title>
                                        Organizaciones: 
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            class="mx-auto elevation-0"
                                            v-model="searchOrgs"
                                            append-icon="mdi-magnify"
                                            label="Buscar"
                                            single-line
                                            hide-details
                                        ></v-text-field>
                                    </v-card-title>
                                    <v-data-table
                                        :custom-filter="filterOrgsText"
                                        :search="searchOrgs"
                                        :headers="headersOrgs"
                                        :items="page.orgs.data"
                                        sort-by="id"
                                        :loading="isLoadingOrgs"
                                        loading-text="Cargando las organizaciones"
                                        item-key="id"
                                        class="elevation-5 pa-1"
                                        :items-per-page="page.orgs.itemsPerPage"
                                    >
                                        <template v-slot:item.actions="{ item }">
                                            <v-icon small class="mr-2" @click="editOrgsItem(item)">
                                                mdi-pencil
                                            </v-icon>
                                        </template>
                                        <template v-slot:loading>
                                            <div style="margin-top: 20px !important; margin-bottom: 600px !important;">
                                                Cargando Organizaciones...
                                            </div>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    <!-- </v-row> -->
                </v-col>
            </v-row>
        </v-container>
        <AdminOffersEdit 
            :item="dialogEdit.offers.item"
            :dialogOffersEdit="dialogEdit.offers.dialog"
            @close="closeDialogEdit"
            @updateItemsList="updateOffersItemsList"
        />
        <AdminOrgsEdit 
            :item="dialogEdit.orgs.item"
            :dialogEdit="dialogEdit.orgs.dialog"
            @close="closeDialogEdit"
            @updateItemsList="updateOrgsItemsList"
        />
    </div>
</template>
<script>
import SideMenu from "@/components/SideMenu";
import AdminOffersEdit from "@/components/AdminOffersEdit";
import AdminOrgsEdit from "@/components/AdminOrgsEdit";
import { currentImg, datetime, handleTxt } from "@/libs/mixins";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

export default {
    name: "AdminOrgsOffers",
    components: {
        SideMenu,
        AdminOffersEdit,
        AdminOrgsEdit
    },
    mixins: [currentImg, datetime, handleTxt],
    data() {
        return {
            isLoadingOffers: false,
            isLoadingOrgs: false,
            isLoadingCloseOffers: false,
            offersLoaded: 0,
            organizations: [],
            searchOffers: "",
            searchOrgs: "",
            addClosed: false,
            pages: {},
            tab: "",
            dialogEdit: {
                orgs: {
                    item: {},
                    dialog: false,
                },
                offers: {
                    item: {},
                    dialog: false,
                }
            },
            page: {
                tab: "",
                limit: 65,
                offers: {
                    index: 1,
                    itemsPerPage: 10,
                    data: [],
                    total: 0
                },
                orgs: {
                    index: 1,
                    itemsPerPage: 10,
                    data: [],
                    total: 0
                }
            },
            headersOffers: [
                {
                    text: "id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                { text: "Titulo", align: "start", value: "title" },
                { text: "Organizacion", align: "start", value: "organization.name" },
                { text: "Peso", align: "start", value: "weight" },
                { text: "Estado", align: "start", value: "status" },
                { text: "Redirección", align: "start", value: "redirect" },
                { text: "Est. Pago", align: "start", value: "tabulated" },
                { text: "", align: "start", value: "actions", sortable: false },
                // {text: "", value: "data-table-expand"},
            ],
            headersOrgs: [
                {
                    text: "id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                { text: "Organizacion", align: "start", value: "name" },
                { text: "Peso", align: "start", value: "weight" },
                { text: "", align: "start", value: "actions", sortable: false },
                // {text: "", value: "data-table-expand"},
            ]
        };
    },
    async created() {
        this.isLoadingOrgs = true;
        this.isLoadingOffers = true;
        
        this.tab = "offers";
        this.page.tab = "offers";
        
        const org = await this.getOrganizations({ role: this.getRole });
        this.page.orgs.data = org.organizations.flat();
        this.page.orgs.total = org.total;
        this.isLoadingOrgs = false;
        
        this.loading = 0;
        
        let params = {
            role: this.getRole, 
            limit: this.page.limit, 
            page: 1,
        };
        const status = ["open", "disable", "review", "failed"];
        params.status = status;     

        const firstQuery = await this.offers(params);        
        this.page.offers.total = firstQuery.total;
        this.offersLoaded = this.toPercentage(this.page.offers.data, firstQuery.total);
        if (this.getCrudOffers.length !== firstQuery.total) {
            let offersArray = firstQuery.offers.flat();

            const pages = Math.ceil(firstQuery.total / this.page.limit);
            for (let i = 2; i < (pages + 1); i++) {
                params.page = i;
                let { offers, total } = await this.offers(params);
                offersArray.push(offers.flat());
                this.offersLoaded = this.toPercentage(offersArray.flat(), total);
            }
            this.page.offers.data = offersArray.flat();
            this.SET_CRUD_OFFERS(this.page.offers.data);
            this.isLoadingOffers = false;
        } else {
            this.page.offers.data = this.getCrudOffers;
            this.offersLoaded = 100;
            this.isLoadingOffers = false;
        }
        
    },
    watch: {
        async addClosed() {
            if (this.addClosed) {
                this.isLoadingCloseOffers = true;
                let params = {
                    role: this.getRole, 
                    limit: this.page.limit, 
                    page: 1,
                };
                let offersArray = [];
                const status = ["close"];
                params.status = status;
                const firstQuery = await this.offers(params);        
                offersArray.push(firstQuery.offers.flat());
                const pages = Math.ceil(firstQuery.total / this.page.limit);
                for (let i = 2; i < (pages + 1); i++) {
                    params.page = i;
                    let { offers, total } = await this.offers(params);
                    offersArray.push(offers.flat());
                }
                this.page.offers.data = [...this.page.offers.data, ...offersArray.flat()];
                this.isLoadingCloseOffers = false;
            } else {
                this.page.offers.data = this.page.offers.data.filter(d => d.status !== "close");
            }
        }
    },
    computed: {
        ...mapGetters("offers", ["getCrudOffers", "getOpen", "getFailed", "getDisable", "getReview", "getClose", "getFiltered"]),
        ...mapGetters("users", ["getRole", "getType"]),
    },
    methods: {
        ...mapActions("organizations", ["getOrganizations"]),
        ...mapMutations("offers", ["SET_CRUD_OFFERS"]),
        ...mapActions("offers", ["open", "review", "failed", "close", "disable", "filter", "offers"]),
        toPercentage(items, total) {
            return parseInt(Math.round((items.length * 100) / total)); 
        },
        changeTab(value) {
            this.page.tab = value;
        },
        editOffersItem(item) {
            const { id, title, weight, organizationId, redirect, tabulated } = item;
            this.dialogEdit.offers.item = { id, title, weight, organizationId, redirect, tabulated };
            this.dialogEdit.offers.dialog = true;
        },
        editOrgsItem(item) {
            const { id, name, weight } = item;
            this.dialogEdit.orgs.item = { id, name, weight };
            this.dialogEdit.orgs.dialog = true;
        },
        closeDialogEdit() {
            this.dialogEdit.offers.item = {};
            this.dialogEdit.offers.dialog = false;
            this.dialogEdit.orgs.item = {};
            this.dialogEdit.orgs.dialog = false;
        },
        updateOffersItemsList(item) {
            this.page.offers.data = this.page.offers.data.map(i => i.id === item.id ? { ...i, weight: item.weight, redirect: item.redirect, tabulated: item.tabulated } : i); 
            this.SET_CRUD_OFFERS(this.page.offers.data);
        },
        updateOrgsItemsList(item) {
            this.page.orgs.data = this.page.orgs.data.map(i => i.id === item.id ? { ...i, weight: item.weight } : i); 
        },
        filterOrgsText(value, search, item) {
            return  value !== null &&
                search !== null &&
                (this.normalized(item.id).includes(this.normalized(search)) || 
                this.normalized(item.name).includes(this.normalized(search)) || 
                this.normalized(item.weight).includes(this.normalized(search)));
        },
        filterOffersText(value, search, item) {
            return  value !== null &&
                search !== null &&
                (this.normalized(item.id).includes(this.normalized(search)) ||
                this.normalized(item.title).includes(this.normalized(search)) ||
                this.normalized(item.status).includes(this.normalized(search)) || 
                this.normalized(item.organization.name).includes(this.normalized(search)) || 
                this.normalized(item.weight).includes(this.normalized(search)));
        }

    }
};  
</script>
<style>
td {
    font-size: 12px !important;
}
</style>
